<div class="outer-container epp-reports-outer-container">
  <app-accordian [title]="'EPP Submission Reports'">
    <div class="reports-grid-container">
      <app-data-grid
        [config]="eppReportGridConfig"
        [pagedata]="eppReportData"
        [statusDataField]="'status'"
        [submittedStatusValues]="['Completed']"
        id="epp_reports_datagrid">
        <ng-template #actionsTemplate let-rowData>
          <div class="report-action-cell">
            <button
              type="button"
              class="action-icon-button report-icon-btn"
              matTooltip="Generate Report"
              matTooltipPosition="above"
              aria-label="Generate report"
              (click)="openGenerateReportModal(rowData); $event.stopPropagation()">
              <img class="icon-default" src="assets/images/Default.svg" alt="Generate Report" />
              <img class="icon-hover" src="assets/images/Hover.svg" alt="Generate Report" />
            </button>
          </div>
        </ng-template>
      </app-data-grid>
    </div>
  </app-accordian>

  <div class="report-modal-overlay" *ngIf="showGenerateReportModal" (click)="closeGenerateReportModal()">
    <div class="report-modal" (click)="$event.stopPropagation()">
      <div class="report-modal-header">
        <h2>Generate Report</h2>
        <img src="assets/images/neveda-images/close.svg" id="close_img"
             class="report-modal-close"
             (click)="closeGenerateReportModal()"
             (keypress)="closeGenerateReportModal()"
             alt="close_icon" tabindex="0">
      </div>

      <div class="report-modal-body">
        <div class="report-field-group">
          <label>Start Date <span class="required">*</span></label>
          <div class="date-input-wrapper">
            <input
              type="text"
              appDateMask
              [(ngModel)]="reportStartDate"
              placeholder="MM/DD/YYYY"
              (dateMaskError)="onStartDateMaskError($event)"
              (ngModelChange)="onDateInputChanged()" />
            <span class="calendar-input-icon">
              <i class="fa fa-calendar"></i>
              <input
                type="date"
                class="calendar-icon"
                [ngModel]="toIsoDate(reportStartDate)"
                [max]="todayIsoDate"
                (ngModelChange)="onStartDatePickerChange($event)" />
            </span>
          </div>
        </div>

        <div class="report-field-group">
          <label>End Date <span class="required">*</span></label>
          <div class="date-input-wrapper">
            <input
              type="text"
              appDateMask
              [(ngModel)]="reportEndDate"
              placeholder="MM/DD/YYYY"
              (dateMaskError)="onEndDateMaskError($event)"
              (ngModelChange)="onDateInputChanged()" />
            <span class="calendar-input-icon">
              <i class="fa fa-calendar"></i>
              <input
                type="date"
                class="calendar-icon"
                [ngModel]="toIsoDate(reportEndDate)"
                [max]="todayIsoDate"
                (ngModelChange)="onEndDatePickerChange($event)" />
            </span>
          </div>
          <div class="text-danger small" *ngIf="dateRangeError">{{ dateRangeError }}</div>
        </div>
      </div>

      <div class="report-modal-footer">
        <button type="button" class="btn btn-outline btn-modal-action btn-radius" (click)="resetGenerateReportFields()">Reset</button>
        <button
          type="button"
          class="btn btn-primary btn-modal-action btn-radius"
          [disabled]="!canDownloadReport"
          (click)="confirmGenerateReportDownload()">
          Download
        </button>
      </div>
    </div>
  </div>
</div>
